export default "__VITE_ASSET__D_VCGr1S__"